import {
  band,
  product,
  regulation,
  smRangeBaseConfig,
} from '../../config-utils';
import NDEquipmentPanel from '../../nd/NDEquipmentPanel';
import { PMPFormPanel } from '../../nd/utils';
import { syncFormState } from './../utils';
import { antennaPanelFields, power } from './PMP450ViewConfig';
import NDAntennaPanel from '../../nd/NDAntennaPanel';
import ScanLossPMP from './ScanLossPMP';

const equipment: PMPFormPanel = {
  kind: 'equipment',
  title: 'Equipment',
  name: 'sm_equipment',
  component: NDEquipmentPanel,
  fields: [
    band,
    product,
    {
      attrName: 'color',
      getter: 'radios.0.equipment.color',
    },
    regulation,
  ],
};

const productPanel: PMPFormPanel = {
  kind: 'product',
  title: 'Product Configuration',
  name: 'sm_product',
  component: NDEquipmentPanel,
  fields: [
    {
      attrName: 'bandwidth',
      getter: 'radios.0.equipment.bandwidth',
    },
    {
      ...smRangeBaseConfig,
      editable: false,
    },
    {
      label: 'Sync',
      attrName: 'sync',
      getter: 'radios.0.equipment.sync',
    },
    {
      attrName: 'symmetry',
      getter: 'radios.0.equipment.symmetry',
    },
    {
      attrName: 'dual_payload',
      getter: 'radios.0.equipment.dual_payload',
      refreshesChoices: true,
    },
    {
      attrName: 'highest_mod_mode',
      getter: 'radios.0.equipment.highest_mod_mode',
      refreshesChoices: true,
    },
    {
      attrName: 'lowest_ethernet_mode',
      getter: 'radios.0.equipment.lowest_ethernet_mode',
      refreshesChoices: true,
    },
  ],
};

const ptp700HcmpAntennaFields = [
  ...antennaPanelFields,
  {
    label: 'Scan Loss',
    attrName: 'sm_scan_loss',
    getter: 'radios.0.antennas.0.config.scan_loss',
    component: ScanLossPMP,
    recalc: true,
    show({ formGetter }) {
      return formGetter('radios.0.equipment.product') === 'PTP 700 BSA HCMP';
    },
  },
];

const antenna: PMPFormPanel = {
  kind: 'antenna',
  title: 'Antenna Configuration',
  name: 'sm_antenna',
  component: NDAntennaPanel,
  fields: ptp700HcmpAntennaFields,
};

const PTP700HCMPViewConfig = {
  syncFormState,
  equipment,
  product: productPanel,
  antenna,
  power,
};
export default PTP700HCMPViewConfig;
